<div class="sidebar-container">
    <div class="sidebar" [ngClass]="{ 'open': isVisible }">
        <div class="scrollable-content-wrapper">
            <div class="white-content-area">
                <p-accordion [value]="[]">
                    @if(menuItems()){
                        @for(menuItem of menuItems(); track menuItem.label; let idx = $index) {
                            <p-accordion-panel class="border-none" [value]="idx" routerLinkActive="child-is-active" #headerRla="routerLinkActive">
                                <p-accordion-header class="border-round-2xl border-none hover:bg-primary-300" [ngClass]="{'bg-primary': headerRla.isActive}">
                                    <ng-template #toggleicon let-active="active">
                                        <i class="pi" [ngClass]="menuItem.icon"></i>
                                    </ng-template>    
                                    <span class="label-accordion">{{menuItem.label}}</span>
                                </p-accordion-header>
                                <p-accordion-content>
                                    @for (tab of menuItem.items; track $index) {
                                        <div class="relative flex items-center gap-2 mt-2 pl-2 group border-round-lg cursor-pointer" [ngClass]="{'hover:bg-primary-300': !rla.isActive}" 
                                            routerLinkActive #rla="routerLinkActive"
                                            [routerLinkActiveOptions]="{ exact: false }"
                                            [routerLink]="tab.route"
                                            (click)="navigateTo(tab.route)">
                                            <span class="p-1 border-round" [ngClass]="{'bg-primary': rla.isActive}"> </span>
                                            <a class="text-sm py-1 text-black-alpha-90 no-underline"
                                            [ngClass]="{'text-primary': rla.isActive}">
                                                {{ tab.label }}
                                            </a>
                                        </div>
                                    }
                                </p-accordion-content>
                            </p-accordion-panel>
                        }
                    }
                </p-accordion>
            </div>
        </div>
    </div>
    <div class="overlay" [ngClass]="{ 'show': isVisible }" (click)="closeSidebar()"></div>
    
    <p-button (click)="toggleSidebar()" icon="pi pi-bars" [text]="true" />
</div>